<template lang="pug">
  .sorting
    button.sorting__button.turquoise(
    :class="active(statusNew)"
    @click.prevent="sorted(statusNew)"
    ) Новые {{ get_count(statusNew) }}
    button.sorting__button.blue(
    :class="active(statusInProgress)"
    @click.prevent="sorted(statusInProgress)"
    ) В работе {{ get_count(statusInProgress) }}
    button.sorting__button.green(
    :class="active(statusApproved)"
    @click.prevent="sorted(statusApproved)"
    ) Подтверждена {{ get_count(statusApproved) }}
    button.sorting__button.orange(
    v-if="showReserveStatus"
    :class="active(statusReserve)"
    @click.prevent="sorted(statusReserve)"
    ) В резерве {{ get_count(statusReserve) }}
    button.sorting__button.carrot(
    v-if="showCanceledStatus"
    :class="active(statusCanceled)"
    @click.prevent="sorted(statusCanceled)"
    ) Отменено {{ get_count(statusCanceled) }}
    button.sorting__button.carrot(
    v-if="showRejectedStatus"
    :class="active(statusRejected)"
    @click.prevent="sorted(statusRejected)"
    ) Отклонено {{ get_count(statusRejected) }}
    button.sorting__button.green(
    :class="active(statusEventAttended)"
    @click.prevent="sorted(statusEventAttended)"
    ) Посетил(а) {{ get_count(statusEventAttended) }}

</template>

<script>
import { OrderStatusEnums } from "../../const";
export default {
  name: "status-filter",
  props: {
    status: {
      type: Array,
      default: () => [],
    },
    showCanceledStatus: {
      type: Boolean,
      default: true,
    },
    showRejectedStatus: {
      type: Boolean,
      default: true,
    },
    showReserveStatus: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      current_status: null,
    };
  },
  computed: {
    statusNew() {
      return OrderStatusEnums.NEW;
    },
    statusInProgress() {
      return OrderStatusEnums.IN_PROGRESS;
    },
    statusApproved() {
      return OrderStatusEnums.APPROVED;
    },
    statusReserve() {
      return OrderStatusEnums.RESERVE;
    },
    statusCanceled() {
      return OrderStatusEnums.CANCELED;
    },
    statusRejected() {
      return OrderStatusEnums.REJECTED;
    },
    statusEventAttended() {
      return OrderStatusEnums.EVENT_ATTENDED;
    },
  },
  methods: {
    get_count(status) {
      if (this.$props.status.length) {
        let list_ = this.$props.status.filter((i) => {
          return i.status === status;
        });
        return list_.length > 0 ? list_[0].total : 0;
      }
      return 0;
    },
    active(status) {
      return status === this.current_status ? "" : "grey";
    },
    sorted(status) {
      if (this.current_status === status) {
        this.current_status = null;
      } else {
        this.current_status = status;
      }
      this.$emit("change", this.current_status);
    },
  },
};
</script>
